import React, { useEffect, useId, useRef, useState } from 'react';
import { loadYouTubePlayer } from './youtubePlayer';

export default function MusicPlayer() {
  const [open, setOpen] = useState(false);
  const [status, setStatus] = useState('loading');
  const panelId = useId();
  const host = useRef(null);
  const player = useRef(null);
  const ready = useRef(false);
  const isOpen = useRef(false);

  useEffect(() => {
    let cancelled = false;
    let instance;
    const container = host.current;
    loadYouTubePlayer().then(YT => {
      if (cancelled) return;
      const iframe = document.createElement('iframe');
      iframe.title = 'Girl Like Me by PinkPantheress — starting at 00:10';
      iframe.src = `https://www.youtube-nocookie.com/embed/D24dn9eXTwA?start=10&autoplay=0&playsinline=1&rel=0&enablejsapi=1&origin=${encodeURIComponent(window.location.origin)}`;
      iframe.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
      iframe.referrerPolicy = 'strict-origin-when-cross-origin';
      iframe.allowFullscreen = true;
      container.appendChild(iframe);
      instance = new YT.Player(iframe, {
        events: {
          onReady: event => {
            if (cancelled) return;
            player.current = event.target;
            ready.current = true;
            setStatus('ready');
            if (isOpen.current) event.target.playVideo();
          },
          onStateChange: event => {
            if (cancelled) return;
            if (event.data === 1) {
              if (!isOpen.current) event.target.pauseVideo();
              else setStatus('playing');
            }
          },
          onAutoplayBlocked: () => { if (!cancelled) setStatus('blocked'); },
          onError: () => { if (!cancelled) setStatus('error'); },
        },
      });
    }).catch(() => { if (!cancelled) setStatus('error'); });
    return () => {
      cancelled = true;
      ready.current = false;
      player.current = null;
      instance?.destroy();
      container.replaceChildren();
    };
  }, []);

  function togglePlayer() {
    const nextOpen = !isOpen.current;
    isOpen.current = nextOpen;
    setOpen(nextOpen);
    if (!ready.current) return;
    if (nextOpen) {
      // Invoke playback directly in the click handler, preserving user activation.
      player.current.seekTo(10, true);
      player.current.playVideo();
    } else {
      player.current.pauseVideo();
    }
  }

  return (
    <>
      <button
        className="music-toggle"
        type="button"
        aria-label={open ? 'Close music player' : 'Play Girl Like Me by PinkPantheress from 00:10'}
        aria-expanded={open}
        aria-controls={panelId}
        onClick={togglePlayer}
      >
        <img src="design/music-note.svg" width="26" height="32" alt="" />
      </button>
      <div id={panelId} className="music-panel" hidden={!open}>
        <p className="music-caption">my recent fav: Girl Like Me · PinkPantheress</p>
        <div ref={host} />
        <p className="music-status" role="status">
          {status === 'loading' && 'Loading music…'}
          {status === 'blocked' && 'Tap ▶ in the player to start the music.'}
          {status === 'error' && 'Player unavailable. Listen on YouTube below.'}
        </p>
        <a href="https://www.youtube.com/watch?v=D24dn9eXTwA&t=10s" target="_blank" rel="noreferrer">Open on YouTube ↗</a>
      </div>
    </>
  );
}
